import React, { useEffect, useState } from "react";
import { ValidateResponse, setCurrentPage, getCurrentPage } from "../../helpers/global";
import { fetchProductInspections, getProductStatus } from "../../helpers/articles";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppArticlesProductInspections({ productId, current, setFilterFields, filterValues, identifier }) {

    let pageSize = 10; // default values ergens globaal opslaan?

    //const { status } = useParams();
    const [inspections, setInspections] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState();

    if (JSON.stringify(filterValues) !== filterString) {
        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, current, setPageNr);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
    }

    let listColumns = [
        { key: "statusLabel", label: "Status", type: "text" },
        { key: "plannedDate", label: "Te keuren voor", type: "date" },
        { key: "inspectDate", label: "Keuringsdatum", type: "date" },
        { key: "inspectionNumber", label: "Keuringsrapport", type: "download", display: "icon", fileName: "documentName", documentType: "inspection" }
    ];

    // Afgevoerd zie je niet... wel afgerond
    const optionsConclusion = [
        { value: "PENDING", label: "Te keuren" }, // new/processing/waiting
        { value: "COMPLETED", label: "Goedgekeurd" }, // new/processing/waiting
        { value: "REJECTED", label: "Afgekeurd" }, // new/processing/waiting
    ]

    // // The filters are set here and send to parent onloaded
    let filterFields = {
        'conclusion': { type: 'select', label: "Status", options: optionsConclusion },
    }

    useEffect(() => {

        const callData = {
            productId: productId,
            context: 'product',
            filters: {
                limitOffset: pageSize * pageNr - (pageSize - 1),
                limitRows: pageSize,
                ...filters
            }
        }

        fetchProductInspections(callData).then((res) => {

            const response = ValidateResponse(res.data, 'inspections');

            if (response.status === 'error') {
                setError(response.message, response.status);
            }
            else {
                if (response.totalCount !== undefined) {
                    setTotalCount(response.totalCount);
                    
            if (loadFilters !== current) {
                setFilterFields(filterFields);
                setLoadFilters(current);
            }
    
                }
                setInspections(response.inspections);
                setIsLoaded(true);
            }
        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });

    }, [productId, filters, setFilterFields, pageNr, pageSize]);

    
    let message = getProductStatus(productId) === 'REMOVED' ? "Huplmiddel is afgevoerd" : null;

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (inspections === undefined || inspections === null || Object.keys(inspections).length === 0) {
        return (
            <>
                <Message type="warning" message={message} />
                <Message type="noData" />
            </>
        );
    }


    return (
        <>
            <Message type="warning" message={message} />

            <List
                columns={listColumns}
                data={inspections}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                totalCount={totalCount}
                pageSize={pageSize}
                setCurrentPage={handlePagination}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}